module.exports = __webpack_public_path__ + "img/Jameson-bottle.3a23f76b.png";